module.exports = require("google-protobuf/google/protobuf/any_pb.js");